export default {
  borderRadius: 8,
}
